export const en = {
  topics: 'topics',
  topics_table: 'Topics Table',
  compare_topics: 'Compare Topics',
  search_by_topic: 'search by topic',
  compare_topic_statement:
    'You must compare between at least two to five topics against Each Other',
  edit_topic: 'Edit Topic',
  add_topic: 'Add Topic',
  topic_name: 'Topic Name',
  select_data_from: 'Re-Grabbing from',
  select_data_to: 'Re-Grabbing to',
  add_topic_cancel_message: 'Are you sure you want to cancel adding topic?',
  edit_topic_cancel_message: 'Are you sure you want to cancel editing topic?',
  topic_info: 'Topic information ',
  keywords: 'Keywords',
  search_by_keyword: 'Search by keyword',
  edit_topic_successfully: 'Topic edited successfully',
  add_topic_successfully: 'Topic added successfully',
  videos_views: 'videos views',
  mentioned_hashtags: 'mentioned hashtags',
  searchs: 'searches',
  search: 'search',
  video: 'video',
  num_of_views: 'number of views',
  influencer: 'influencers/entities',
  followers: 'followers',
  following: 'following',
  hashtags: 'hashtags',
  mentions: 'mentions',
  num_of_mentions: 'number of mentions',
  news_topics: 'news/topic',
  news: 'news',
  most_viewed_videos: 'most viewed videos',
  top_influencer: 'top influencers/entities',
  most_mentioned: 'most mentioned hashtags',
  topics_details: 'topic details',
  number_of_topics: 'number of topics',
  topics_categories: 'topics categories',
  totalOfMentions: 'TOTAL No. of Mentions',
  totalParticipnce: 'Total participnce',
  relatedKeywords: 'Related Keywords',
  total_topics: 'Total Topics',
  trending_topics: 'Trending Topics',
  topics_category: 'Topics/Category',
  num_of_topics: 'Number of topics added',
  media: 'media',
  participance: 'participance',
  hashtag_post: 'hashtag tweet',
  totalNO: 'total NO.',
  item: 'Item',
  totalSearches: 'TOTAL SEARCHES',
  check_related: 'check related items',
  total_mentions: 'total mentions',
  posts: 'tweets',
  post: 'tweet',
  total_participants: 'total participants',
  sources: 'sources',
  source: 'source',
  grabbing_info: 'grabbing info',
  name: 'name',
  nickname: 'nickname',
  data_info: 'data info',
  data_from: 'data from',
  data_to: 'data to',
  re_grabbing_period: 're-grabbing period',
  related_words: 'related words',
  topic_type: 'Topic type/ topic',
  Trending_rank: 'trending rank',
  searches: 'searches',
  rank: 'rank',
  top_inf_entities: 'Top Influencers/Entities',
  Influencers_entities: 'Influencers/entities',
  top_mentioned_country: 'top mentioned country',
  interest: 'interest',
  attach_topics: 'Attach Topics',
  trending_topics_table: 'trending topics table',
  topic_category: 'topic category',
  items_related_to: 'Note: this is only the profile items related to',
  no_more_items: 'no more items',
  topics_world_map: 'topics world map',
  intereset: 'intereset',
  never_interested: 'never interested',
  search_count: 'Total Searches',
  topic: 'topic',
  video_publish_date: 'video publish date',
  hashtag_post: 'hashtag tweet',
  linkedin_posts:'linkedin posts',
  analyzed_category: 'ANALYZED CATEGORY TO TOPICS',
  search_count: 'Total searches',
  name_validation_min: 'Name field must be at least 2 chars',
  name_validation_max: 'Name field must be at most 150 chars',
  h: 'H',
  never_interest: 'never interest',
  all: 'All',
  information: 'Information',
  are_you_want_to_grabbing_the_data: 'are you want to grab the topic data',
  grabbing_not_completed_grabbing_the_data:
    'data is not grabbed completely. Do you want to complete grabbing it ',
  grabbing_topic: 'Working on grabbing',
  participants: 'Participants',
  allparticipants: 'All Participants',
  analyzedParticipants: 'Analyzed Participants',
  unAnalyzedParticipants: 'Un-Analyzed Participants',
  sort_by: 'Sort By ',
  latest: 'Latest',
  most_matched: 'Most Matched',
  most_engagement: 'Most Engagement',
  related_hashtags: 'related hashtags',
  related_keyword: 'related keyword',
};

export const ar = {
  related_hashtags: 'هاشتاقات ذات صلة',
  related_keyword: 'كلمات ذات صلة',
  participants: 'المشاركون',
  allparticipants: 'جميع المشاركين',
  analyzedParticipants: 'المشاركين المحللين',
  unAnalyzedParticipants: 'المشاركين الغير محللين',

  are_you_want_to_grabbing_the_data:
    ' هل انت متأكد انك تريد جلب بيانات الموضوع ',
  grabbing_topic: ' جاري العمل على الموضوع ',
  grabbing_not_completed_grabbing_the_data:
    ' لم يتم جلب البيانات بالكامل ، هل تريد استكمال جلب بيانات الموضوع ',
  name_validation_min: 'الإسم لا يجب ان يقل عن حرفين',
  name_validation_max: 'الإسم  يجب ان  لا يتجاوز 150 حرف',
  topic_category: 'فئه الموضوع',
  analyzed_category: 'الفئه المحلله للموضوعات ',
  attach_topics: 'إضافة الموضوع',
  never_interested: 'غير مهتم دائما',
  trending_topics_table: 'جدول الموضوعات الترند',
  add_topic: 'إضافة موضوع',
  edit_topic: 'تعديل الموضوع',
  topics: 'الموضوعات ',
  topics_table: 'جدول الموضوعات ',
  compare_topics: 'مقارنة الموضوعات ',
  search_by_topic: 'بحث بأسم الموضوع',
  select_data_from: 'جلب البيانات من تاريخ',
  select_data_to: 'جلب البيانات إلى تاريخ',
  edit_topic_cancel_message: 'هل أنت متأكد أنك تريد إلغاء تعديل الموضوع؟',
  add_topic_cancel_message: 'هل أنت متأكد أنك تريد إلغاء إضافة الموضوع؟',
  topic_info: 'معلومات الموضوع',
  keywords: 'الكلمات',
  search_by_keyword: 'إبحث بالكلمة',
  add_topic_successfully: 'تم إضافة الموضوع بنجاح',
  edit_topic_successfully: 'تم تعديل الموضوع بنجاح',
  topics_categories: 'فئات الموضوعات',
  number_of_topics: 'عدد الموضوعات',
  topics_table: 'جدول الموضوعات ',
  compare_topics: 'مقارنة الموضوعات',
  search_by_topic: 'بحث بأسم الموضوع',
  compare_topic_statement:
    'يجب أن تقارن بين ما لا يقل عن اثنين إلى خمسة موضوعات ضد بعضها البعض ',
  videos_views: 'مشاهدات الفيديوهات',
  mentioned_hashtags: 'الهاشتاقات ذات إشارة',
  searchs: 'الابحاث',
  search: 'البحث',
  video: 'الفيديو',
  num_of_views: 'عدد المشاهدات',
  influencer: 'المؤثرون/الكيانات',
  Following: 'المُتابَعين',
  Followers: 'المُتابِعين',
  hashtags: 'الهاشتاقات',
  mentions: 'الإشارات',
  num_of_mentions: 'عدد الإشارات',
  news_topics: 'الاخبار/موضوع',
  news: 'الاخبار',
  most_viewed_videos: 'الفيديوهات الأكثر مشاهدة',
  top_influencer: 'أعلى المؤثرين/الكيانات',
  most_mentioned: ' الهاشتاقات الأكثر إشارة',
  topics_details: 'تفاصيل الموضوع',
  topic_name: 'اسم الموضوع',
  totalOfMentions: 'إجمالي عدد الإشارات',
  totalParticipnce: 'إجمالي المشاركة',
  relatedKeywords: 'كلمات ذات صلة',
  sort_by: 'ترتيب حسب ',
  latest: ' الاحدث',
  most_matched: ' الاكثر تطابق',
  most_engagement: ' الاعلي تفاعل',
  total_topics: 'إجمالي الموضوعات',
  trending_topics: 'الموضوعات الترند',
  topics_category: 'الموضوعات / الفئة',
  num_of_topics: 'عدد الموضوعات المضافة',
  media: 'الوسائط',
  participance: 'المشاركة',
  hashtag_post: ' التغريدات',
  linkedin_posts:'منشورات لينكدان',
  totalNO: 'المجموع',
  item: 'عنصر',
  totalSearches: 'إجمالي عمليات البحث',
  check_related: 'تحقق من العناصر ذات الصلة',
  total_mentions: 'إجمالي الإشارات',
  posts: 'تغريدات',
  post: 'تغريدة',
  total_participants: 'إجمالي المشاركون',
  sources: 'المصادر',
  source: 'مصدر',
  grabbing_info: 'جلب البيانات',
  name: 'اسم',
  nickname: 'الاسم المستعار',
  data_info: 'معلومات البيانات',
  data_from: 'البيانات من',
  data_to: 'البيانات إلى',
  re_grabbing_period: 'فترة إعادة الجلب',
  related_words: 'الكلمات ذات الصلة',
  topic_type: 'نوع الموضوع/الموضوع',
  Trending_rank: 'ترتيب الترند',
  searches: 'الابحاث',
  rank: 'مرتبة',
  top_inf_entities: 'أعلى المؤثرين / الكيانات',
  Influencers_entities: 'المؤثرون/الكيانات',
  top_mentioned_country: 'البلد الأكثر إشارة',
  interest: 'المهتمين',
  items_related_to: 'ملحوظة: هذه هي فقط الموضوعات المرتبطة ب ',
  no_more_items: 'لا يوجد عناصر اخرى',
  topics_world_map: 'الانتشار حول العالم للموضوعات',
  intereset: 'مهتمين',
  search_count: 'إجمالي البحث',
  topic: 'الموضوع',
  video_publish_date: 'موعد نشر الفيديو',
  hashtag_post: 'التغريدات ',
  search_count: 'إجمالي البحث',
  h: 'س',
  never_interest: 'غير مهتم',
  information: 'معلومات',
};
